import { Component, OnInit, Inject } from '@angular/core';
import { MAT_DIALOG_DATA } from '@angular/material/dialog';

@Component({
  selector: 'app-lister-dialog',
  templateUrl: './lister-dialog.component.html',
  styleUrls: ['./lister-dialog.component.scss']
})
export class ListerDialogComponent implements OnInit {

  title: string;
  list: string[];
  secondList = {};
  healthcheckTextDict = {
    'STANDARD': 'HEALTHCHECK.STANDARD',
    'STANDARD_WITH_FOOD': 'HEALTHCHECK.STANDARD_WITH_FOOD',
    'NON_STANDARD': 'HEALTHCHECK.NON_STANDARD'
  };
  isHealthcheck = false;

  constructor(
    @Inject(MAT_DIALOG_DATA) data: {title: string, list: string[], isHealthcheck: boolean, secondList?}
  ) {
    this.title = data.title;
    this.list = data.list;
    this.secondList = data?.secondList;
    this.isHealthcheck = data.isHealthcheck;
  }

  ngOnInit() {
  }

}
